// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Logo_mainWrapper__jY6A1","Word":"Logo_Word__TCJBy","logoImage":"Logo_logoImage__ag-H8"};